module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.18039/js/img/valuePropModals/ReportBuilder/ValueProp2.svg"